import Vue from 'vue'
import axios from 'axios'
import urlFiltersHelper from '@/helpers/urlFiltersHelper'
import router from '@/router'
import constants from '@/helpers/constants'
import formattedShopData from '@/helpers/shops/formattedShopData'

export default {
  state: {
    shops: [],
    serviceCenters: [],
    services: [],
    cities: [],
    selectedCity: {},
    filters: {},
    filteredFlags: {
      [constants.SHOPS_FILTERS_FLAGS.SERVICES]: {},
      [constants.SHOPS_FILTERS_FLAGS.OPENED]: false,
      [constants.SHOPS_FILTERS_FLAGS.NEAR_SUBWAY]: false
    },
    isShowFiltersModal: false
  },
  getters: {
    shopsByCities: (state, getters, rootState) => {
      let result = {}

      state.cities.forEach(city => {
        result[city.name[rootState.translation.language]] = []
      })

      result = state.shops.reduce((acc, shop) => {
        if (acc[shop.city]) {
          acc[shop.city].push(shop)
        } else {
          acc[shop.city] = [shop]
        }

        return acc
      }, result)
      return result
    }
  },
  mutations: {
    SET_SELECTED_CITY: (state, city) => {
      state.selectedCity = city
    },
    SET_SHOPS: (state, data) => {
      state.shops = formattedShopData(data, constants.MAP_PLACEMENTS.SHOPS)
    },
    SET_SERVICE_CENTERS: (state, data) => {
      state.serviceCenters = formattedShopData(data, constants.MAP_PLACEMENTS.SERVICES)
    },
    SET_SERVICES: (state, data) => {
      state.services = data.services.filter(service => {
        for (let i in data.stores) {
          if (data.stores.hasOwnProperty(i) && !data.stores[i].services.map(item => item.key).includes(service.key)) {
            return service
          }
        }
      })
    },
    SET_CITIES: (state, cities) => {
      state.cities = cities
    },
    SET_SHOPS_FILTERS: (state, data) => {
      state.filters = data
    },
    SET_SHOPS_FILTERS_FROM_URL: (state, data) => {
      state.filters = data
    },
    SET_FILTERED_FLAGS: (state, flag) => {
      if (flag.type === 'service') {
        Vue.set(state.filteredFlags[constants.SHOPS_FILTERS_FLAGS.SERVICES], flag.key, flag.value)
      } else {
        Vue.set(state.filteredFlags, flag.key, flag.value)
      }
    },
    SET_IS_SHOW_FILTERS_MODAL: (state, bool) => {
      state.isShowFiltersModal = bool
    }
  },
  actions: {
    GET_SHOPS: ({ commit, rootGetters }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/site/get-stores/')
          .then(response => {
            if (response.status === 200 && response.data) {
              commit('SET_SHOPS', response.data.stores)
              commit('SET_SERVICES', response.data)
              commit('SET_CITIES', response.data.cities)
              commit('SET_SELECTED_CITY', response.data.cities[0])
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GET_SERVICES: ({ commit, rootGetters }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/site/get-services/')
          .then(response => {
            if (response.status === 200 && response.data) {
              commit('SET_SERVICE_CENTERS', response.data.services)
              commit('SET_CITIES', response.data.cities)

              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    SET_SELECTED_CITY_ACTION: ({ commit }, city) => {
      commit('SET_SELECTED_CITY', city)
    },
    SET_SHOPS_FILTERS_ACTION: ({ commit }, data) => {
      commit('SET_SHOPS_FILTERS', data)
    },
    SET_SHOPS_FILTERS_FROM_URL_ACTION: ({ commit }) => {
      const parsedFilters = urlFiltersHelper.parseData(window.location.search)

      if (Object.keys(parsedFilters).length) {
        commit('SET_SHOPS_FILTERS_FROM_URL', parsedFilters)
      }
    },
    SET_FILTERS_TO_URL: ({ state }) => {
      const urlParsedSearchParams = urlFiltersHelper.parseData(window.location.search)

      let additionalSearchData = {}

      for (let key in urlParsedSearchParams) {
        if (!Object.keys(state.filters).includes(key) &&
          key !== constants.SHOPS_FILTERS_FLAGS.SERVICES &&
          key !== constants.SHOPS_FILTERS_FLAGS.OPENED &&
          key !== constants.SHOPS_FILTERS_FLAGS.NEAR_SUBWAY
        ) {
          additionalSearchData[key] = urlParsedSearchParams[key]
        }
      }

      router.push({ query: { ...urlFiltersHelper.mappedData(state.filters), ...additionalSearchData } })
        .catch(() => {})
    },
    SET_FILTERED_FLAGS_ACTION: ({ commit }, flag) => {
      commit('SET_FILTERED_FLAGS', flag)
    },
    SET_IS_SHOW_FILTERS_MODAL_ACTION: ({ commit }, bool) => {
      commit('SET_IS_SHOW_FILTERS_MODAL', bool)
    }
  }
}
